import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const INITIAL = { personal: null, org: null, personalDone: false, orgDone: false };

// Brukerens egne fakturavilkår: invoiceCustomers/user_<uid> og, for org-medlemmer, org_<orgId>.
export function useMyInvoiceTerms({ uid, orgId }) {
  const [state, setState] = useState(INITIAL);

  useEffect(() => {
    setState({ ...INITIAL, orgDone: !orgId });
    if (!uid) { setState(s => ({ ...s, personalDone: true })); return undefined; }

    const listen = (id, key, doneKey) => onSnapshot(
      doc(db, 'invoiceCustomers', id),
      snap => setState(s => ({
        ...s,
        [key]: snap.exists() ? { id: snap.id, ...snap.data() } : null,
        [doneKey]: true,
      })),
      err => {
        console.error(`invoiceCustomers/${id}`, err);
        setState(s => ({ ...s, [key]: null, [doneKey]: true }));
      },
    );

    const unsubs = [listen(`user_${uid}`, 'personal', 'personalDone')];
    if (orgId) unsubs.push(listen(`org_${orgId}`, 'org', 'orgDone'));
    return () => unsubs.forEach(u => u());
  }, [uid, orgId]);

  return { personal: state.personal, org: state.org, loading: !(state.personalDone && state.orgDone) };
}
